import React from 'react';
import { Pill } from '@appd/uik';
import { DemoTagProps } from './models';

const DemoTags: React.FC<DemoTagProps> = ({ tags }) => {
  return (
    <div className="flex gap-2 flex-wrap">
      {tags?.map(({ category, value }) => (
        <Pill key={`${value} (${category})`} disabled label={`${value} (${category})`} />
      ))}
    </div>
  );
};

export default DemoTags;
